module.exports = __webpack_public_path__ + "static/horus_06-dceece062ece87e9923b65fb700040df.jpg";